import React, { useCallback, useMemo } from "react";
import { Box, Button, Typography } from "@mui/material";
import CloudImage from "../../../../components/Vectors/CloudImage";
import { useDropzone } from "react-dropzone";
import { useDispatch } from "react-redux";
import { add } from "../../../../store/uploadingFileSlice";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 10,
  borderColor: "#D9D9D9",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#949292",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const focusedStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

const DragAndDropZone = () => {
  const dispatch = useDispatch();

  const onDrop = useCallback(
    (acceptedFiles, rejectedFiles) => {
      dispatch(add(acceptedFiles));
    },
    [dispatch]
  );

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isFocused,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    accept: { "text/*": [".xml"] },
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  return (
    <Box mt={"16px"} justifyContent={"center"} {...getRootProps({ style })}>
      <Box style={{ padding: "40px 0px" }}>
        <input {...getInputProps()} />

        <Box
          display={"flex"}
          flexDirection={"column"}
          style={{ padding: "16px 0px" }}
          alignItems={"center"}
        >
          <CloudImage />

          <Button variant="contained">Adicionar Notas</Button>
        </Box>

        <Typography
          sx={{
            fontWeight: 400,
            textAlign: "center",
            color: "#00010C",
          }}
          noWrap
          component={"span"}
        >
          {isDragActive ? (
            <p>Solte os arquivos aqui ...</p>
          ) : (
            <p>ou arraste e solte arquivos nesta caixa</p>
          )}
        </Typography>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: 14,
            textAlign: "center",
          }}
          color="inherit"
          noWrap
        >
          Carregar somente arquivos em XML.<br></br> Você pode baixar o arquivo
          XML das suas notas fiscais <br></br>através do Portal Nacional da
          Secretaria da Fazenda
        </Typography>
      </Box>
    </Box>
  );
};

export default DragAndDropZone;
